var React = require('react');

function ButtonPause (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2","width":"3","height":"17","fill":"white","key":0}),React.createElement("rect",{"x":"8","width":"3","height":"17","fill":"white","key":1})]);
}

ButtonPause.defaultProps = {"width":"13","height":"17","viewBox":"0 0 13 17","fill":"none"};

module.exports = ButtonPause;

ButtonPause.default = ButtonPause;
